// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_g7ZIR","secondaryColumnCell":"secondary-column-cell_g7ZIR","name":"name_RgG5G"};